/** Fusion rôle ∪ grade ∪ extras fiche — uniquement les access_* du menu. */
export const extractUserAccesses = (userData) => {
    const accesses = [];
    const push = (list) => {
        (list || []).forEach((p) => {
            if (p?.nom?.startsWith('access_')) accesses.push(p.nom);
        });
    };
    push(userData?.role?.permissions);
    push(userData?.grade?.permissions);
    push(userData?.permissions);
    return [...new Set(accesses)];
};
